<template>
  <nav class="bg-white border-b sticky top-0 z-50 border-gray-200">
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <div class="flex justify-between h-16">
        <nav class="flex desktop-nav w-full">
          <div class="flex-shrink-0 flex items-center mr-5">
            <router-link
              :to="{name: 'home'}"
              aria-label="Home Page"
              class="px-2 focus:outline-none text-xs focus:shadow-outline-green flex items-end"
              @click.native="menu = false"
            >
              <img
                class="block h-16 w-auto py-2"
                src="../../assets/juno_logo.png"
                alt="LeverEdge Logo"
              />
              <span class="text-gray-300 pb-2 ml-2">v{{ version }}</span>
            </router-link>
          </div>
          <div
            v-if="currentRoute.name !== 'onboarding'"
            class="flex flex-row w-full sm:-my-px sm:ml-6 sm:flex justify-end sm:justify-start"
          >
            <router-link
              :to="{ name: 'browse.quotes' }"
              class="nav-item border-b-4 focus:outline-none focus:shadow-outline-green"
              exact
            >
              Browse
              <span class="ml-1 hidden sm:inline">Quotes</span>
            </router-link>

            <router-link
              :to="{ name: 'share.quotes' }"
              exact
              class="nav-item border-b-4 focus:outline-none focus:shadow-outline-green"
            >
              Share
              <span class="ml-1 hidden sm:inline">Your Quotes</span>
            </router-link>
          </div>
        </nav>
      </div>
    </div>

    <transition name="slide-down-fade">
      <div
        v-show="menu"
        aria-hidden="true"
        class="sm:hidden absolute w-full bg-white border-b border-gray-300 left-0 z-50"
      >
        <nav class="pt-2 pb-3 mobile-nav">
          <router-link
            :to="{ name: 'browse.quotes' }"
            @click.native="menu = false"
            exact
            aria-label="Browse Quotes"
            class="nav-item pl-3 pr-4 py-2 border-l-4 text-base font-medium border-transparent
          text-gray-600 hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300
          focus:outline-none focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300
          transition duration-150 ease-in-out"
          >
            Browse Quotes
          </router-link>

          <router-link
            :to="{ name: 'share.quotes' }"
            @click.native="menu = false"
            exact
            aria-label="Share Your Quote"
            class="nav-item mt-1 pl-3 pr-4 py-2 border-l-4 text-base font-medium border-transparent
          text-gray-600 hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300
          focus:outline-none focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300
          transition duration-150 ease-in-out"
          >
            Share your Quotes
          </router-link>
        </nav>
      </div>
    </transition>
  </nav>
</template>

<script>
import { version } from '../../../package.json';

export default {
  name: 'PageNavigation',
  data() {
    return {
      version,
      menu: false,
    };
  },
  computed: {
    currentRoute() {
      return this.$route;
    },
  },
};
</script>

<style>
  .desktop-nav .nav-item,
  .mobile-nav .nav-item {
    @apply flex justify-center items-center mt-1 pl-3 pr-4 py-2 text-base font-medium
    border-transparent text-gray-600 transition duration-150 ease-in-out
  }

  nav .nav-item.router-link-active {
    @apply border-green-500 text-base text-green-500 font-medium outline-none;
  }

  nav .nav-item.router-link-active:focus {
    @apply text-green-500 border-green-500;
  }
</style>
